// import React, { useEffect, useState } from 'react';

// import axios from 'axios';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth'; 
// // import Sidebar from '../../components/Sidebar';
// // import Topbar from '../../components/Topbar';
// import { Link } from 'react-router-dom';

// const DoctorDashboard = () => {
//   const { user } = useAuth();
//   const [appointments, setAppointments] = useState([]);
//   const [summary, setSummary] = useState({ total: 0, completed: 0, pending: 0, cancelled: 0 });

//   useEffect(() => {
//     const fetchAppointments = async () => {
//       try {
//         const today = new Date().toISOString().split('T')[0];
//         const response = await axios.get(`${API_PATH}/appointments?doctor_id=${user.id}&date=${today}`);
//         setAppointments(response.data);

//         const completed = response.data.filter(a => a.status === 'Completed').length;
//         const pending = response.data.filter(a => a.status === 'Pending').length;
//         const cancelled = response.data.filter(a => a.status === 'Cancelled').length;

//         setSummary({
//           total: response.data.length,
//           completed,
//           pending,
//           cancelled
//         });
//       } catch (error) {
//         console.error('Error fetching appointments', error);
//       }
//     };

//     fetchAppointments();
//   }, [user.id]);

//   return (
//     <div className="container mt-4">
//           <h4>className="mb-4">Doctor Dashboard</h4>

//           {/* Doctor Info */}
//           <div className="card mb-4">
//             <div className="card-body">
//               <h5 className="card-title">Welcome, Dr. {user.first_name} {user.last_name}</h5>
//               <p className="card-text">Specialization: {user.specialization || 'N/A'}</p>
//               <p className="card-text">Department: {user.department || 'N/A'}</p>
//             </div>
//           </div>

//           {/* Appointment Summary */}
//           <div className="row text-center ">
//             <div className="col-md-3">
//               <div className="card">
//                 <div className="card-body">
//                   <h6>Total</h6>
//                   <p className="lead">{summary.total}</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="card">
//                 <div className="card-body">
//                   <h6>Completed</h6>
//                   <p className="lead">{summary.completed}</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="card">
//                 <div className="card-body">
//                   <h6>Pending</h6>
//                   <p className="lead">{summary.pending}</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="card">
//                 <div className="card-body">
//                   <h6>Cancelled</h6>
//                   <p className="lead">{summary.cancelled}</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Today's Appointments */}
//           <div className="card mb-4">
//             <div className="card-body">
//               <h5 className="card-title mb-3">Today’s Appointments</h5>
//               {appointments.length === 0 ? (
//                 <p>No appointments scheduled for today.</p>
//               ) : (
//                 <div className="table-responsive">
//                   <table className="table table-bordered">
//                     <thead className="table-light">
//                       <tr>
//                         <th>Time</th>
//                         <th>Patient</th>
//                         <th>Status</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {appointments.map((appt, index) => (
//                         <tr key={index}>
//                           <td>{appt.time}</td>
//                           <td>{appt.patient_name}</td>
//                           <td>{appt.status}</td>
//                           <td>
//                             <Link to={`/doctor/appointments/${appt.id}`} className="btn btn-sm btn-info">
//                               View
//                             </Link>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Quick Actions */}
//           <div className="d-flex flex-wrap gap-2">
//             <Link to="/doctor/home/calendar" className="btn btn-primary">View Calendar</Link>
//             <Link to="/doctor/home/patients" className="btn btn-secondary">Patient History</Link>
//             <Link to="/doctor/home/prescriptions" className="btn btn-success">Prescriptions</Link>
//           </div>
//         </div>
     
   
//   );
// };

// export default DoctorDashboard;




// import React from 'react';

// import { Card, Table, Button } from 'react-bootstrap';

// const DoctorDashboard = () => {
//   const patientData = [
//     { date: '17 Dec, 21', name: 'Steven Cooper', condition: 'Hypertension', treatment: 'Lifestyle + Drugs', status: 'Completed' },
//     { date: '12 Dec, 21', name: 'Sarah Taylor', condition: 'Arthritis', treatment: 'Medication', status: 'Pending' },
//     { date: '10 Dec, 21', name: 'Michael Bruce', condition: 'Heart Murmur', treatment: 'Checkup', status: 'In Progress' },
//     { date: '05 Dec, 21', name: 'Jacob Jones', condition: 'Asthma', treatment: 'Ventilation + Medication', status: 'Completed' },
//     { date: '01 Dec, 21', name: 'Kathryn Murphy', condition: 'Diabetes', treatment: 'Medication', status: 'Pending' },
//   ];

//   return (
//     <div className="container py-4">
//       <Card className="mb-4 shadow-sm border-0">
//         <Card.Body className="d-flex align-items-center">
//           <img
//             src="https://randomuser.me/api/portraits/men/75.jpg"
//             alt="Doctor"
//             className="rounded-circle me-3"
//             width="80"
//             height="80"
//           />
//           <div>
//             <h4 className="mb-0">Dr. Olivia Martin</h4>
//             <div className="text-muted">Cardiologist</div>
//             <div className="text-muted">olivia@email.com</div>
//             <div className="text-muted">1300 Technologic Dr, Ohio, Hawaii 82051</div>
//           </div>
//         </Card.Body>
//       </Card>

//       <Card className="mb-4 shadow-sm border-0">
//         <Card.Body className="d-flex justify-content-between">
//           <div>
//             <div className="text-muted">GPA</div>
//             <h5>3.89</h5>
//           </div>
//           <div>
//             <div className="text-muted">Experience</div>
//             <h5>12+ Years</h5>
//           </div>
//           <div>
//             <div className="text-muted">Rating</div>
//             <h5>4.8 / 5.0</h5>
//           </div>
//           <div>
//             <Button variant="success">Get Profile</Button>
//           </div>
//         </Card.Body>
//       </Card>

//       <Card className="shadow-sm border-0">
//         <Card.Header className="bg-white">
//           <h5 className="mb-0">Patient Treatment</h5>
//         </Card.Header>
//         <Card.Body className="p-0">
//           <Table striped hover className="mb-0">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Patient Name</th>
//                 <th>Condition</th>
//                 <th>Treatment</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {patientData.map((patient, idx) => (
//                 <tr key={idx}>
//                   <td>{patient.date}</td>
//                   <td>{patient.name}</td>
//                   <td>{patient.condition}</td>
//                   <td>{patient.treatment}</td>
//                   <td>
//                     <span className={`badge ${
//                       patient.status === 'Completed'
//                         ? 'bg-success'
//                         : patient.status === 'Pending'
//                         ? 'bg-warning text-dark'
//                         : 'bg-info text-dark'
//                     }`}>
//                       {patient.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </Card.Body>
//       </Card>
//     </div>
//   );
// };

// export default DoctorDashboard;






import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'chart.js/auto';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import axios from 'axios';
import { Bar, Line, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
} from "chart.js";
import 'bootstrap/dist/css/bootstrap.min.css';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
);

const appointmentsChartData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [
    {
      label: "Appointments",
      data: [10, 15, 8, 20, 13, 18, 10, 14, 17, 12, 19, 23],
      backgroundColor: "#217670"
    }
  ]
};

const revenueChartData = {
  labels: appointmentsChartData.labels,
  datasets: [
    {
      label: "Revenue",
      data: [1200, 1500, 1100, 1600, 1700, 1550, 1400, 1350, 1800, 1750, 2000, 2200],
      fill: false,
      borderColor: "#20c997"
    }
  ]
};

const ageRadarData = {
  labels: ["18-25", "26-35", "36-45", "46-55", "56-65"],
  datasets: [
    {
      label: "Patients Age Distribution",
      data: [12, 19, 10, 5, 8],
      backgroundColor: "rgba(23,162,184,0.2)",
      borderColor: "#17a2b8"
    }
  ]
};



const Dashboard = () => {

 const [appointments, setAppointments] = useState([]);
  const { user, token } = useAuth();
  const doctorId = user?.id;
 
console.log(user,token); // Should include the right role

useEffect(() => {
  const fetchAppointments = async () => {
    try {
      const response = await axios.get(`${API_PATH}/appointments/doctor/${doctorId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setAppointments(response.data);
    } catch (err) {
      console.error('Failed to fetch appointments', err);
    }
  };

  if (doctorId && token) {
    fetchAppointments();
  }
}, [doctorId, token]);


 return (
  <div className="container-fluid p-4 bg-light" style={{ minHeight: '100vh' }}>
    {/* Doctor Profile & Stats */}
    <div className="row g-3 align-items-center mb-4 c-overlay">
      <div className="col-md-2 text-center">
        <img
          src={user.profileImg || '/logo512.png'}
          alt="Profile"
          className="rounded-circle shadow"
          style={{ width: 80, height: 80, objectFit: 'cover' }}
        />
      </div>

      <div className="col-md-3">
        <h5 className="mb-1 fw-semibold text-white">{user.fullName}</h5>
        <p className=" mb-1 text-white">{user.speciality || 'Specialist'}</p>
        <div style={{ color: '#ffc107' }}>⭐⭐⭐⭐☆</div>
      </div>

      <div className="col-md d-flex gap-3 justify-content-end flex-wrap">
        <div className="bg-white shadow-sm rounded-4 p-3 text-center" style={{ minWidth: '150px' }}>
          <div className="text-primary fs-4 fw-bold">688</div>
          <div className="text-muted">Total Patients</div>
        </div>
        <div className="bg-white shadow-sm rounded-4 p-3 text-center" style={{ minWidth: '150px' }}>
          <div className="text-success fs-4 fw-bold">30</div>
          <div className="text-muted">Today Patients</div>
        </div>
        <div className="bg-white shadow-sm rounded-4 p-3 text-center" style={{ minWidth: '150px' }}>
          <div className="text-info fs-4 fw-bold">$5830</div>
          <div className="text-muted">Revenue</div>
        </div>
      </div>
    </div>

    {/* Appointments Overview + Table */}
    <div className="row g-4 mb-4">
      <div className="col-md-4">
        <div className="bg-white p-3 shadow rounded-4 h-100">
          <h4 className="mb-3">Appointments Overview</h4>
          <Bar data={appointmentsChartData} />
        </div>
      </div>

      <div className="col-md-8">
        <div className="bg-white p-3 shadow rounded-4 h-100">
          <h4 className="mb-3">Appointments</h4>
          <div className="table-responsive">
            <table className=" table-hover align-middle">
              <thead className="tableborder">
                <tr>
                  <th>#</th>
                  <th>Patient</th>
                  <th>Email</th>
                  <th>Time</th>
                  <th>Diagnosis</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {appointments.map((appt, index) => (
                  <tr key={appt.id} className='datahover'>
                    <td>{index + 1}</td>
                    <td>{`${appt.patientFirstName} ${appt.patientLastName}`}</td>
                    <td>{appt.patientEmail}</td>
                    <td>{`${appt.startTime} - ${appt.endTime}`}</td>
                    <td>{appt.reason}</td>
                    <td>
                      <span className={`badge ${appt.appointmentType === 'General' ? 'bg-warning' : 'bg-info'}`}>
                        {appt.appointmentType}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${appt.status === 'Scheduled' ? 'bg-success' : 'bg-secondary'}`}>
                        {appt.status}
                      </span>
                    </td>
                    <td>
                        <Link to={`/doctor/home/view-appointment/${appt.id}`}>
                          <button className="btn btn-sm btn-outline-primary">View</button>
                        </Link>
                    </td>
                  </tr>
                ))}
                {appointments.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">No appointments found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    {/* Revenue + Age Charts */}
    <div className="row g-4">
      <div className="col-md-6">
        <div className="bg-white p-3 shadow rounded-4 h-100">
          <h4 className="mb-3">Revenue Statistics</h4>
          <Line data={revenueChartData} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="bg-white p-3 shadow rounded-4 h-100">
          <h4 className="mb-3">Patient Age Analysis</h4>
          <Radar data={ageRadarData} />
        </div>
      </div>
    </div>
  </div>
);

};

export default Dashboard;
